import React from "react";
import { Provider } from "react-redux";
import { store } from "../redux/store/store";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "../views/Home";
import RoleSelection from "../views/RoleSelection"; // Add this import
import AdminAuth from "../views/AdminAuth"; // Add this import
import AdminDashboard from "../views/AdminDashboard"; // Add this import
import AssetManagement from "../views/AssetManagement";
import Room from "../views/Room";
import Name from "../views/Name";
import Gameboard from "../views/Gameboard";
import Cardoverlay from "../views/Cardoverlay";
import Cardoverlay1 from "../views/Cardoverlay1";
import Cardoverlays from "../views/Cardoverlays";
import Cardoverlay3 from "../views/Cardoverlay3";
import Opensituation from "../views/Opensituation";
import Cardoverlayevry from "../views/Cardoverlayevry";
import CardoverlayCommon from "../views/CardoverlayCommon";
import Dealopen from "../views/Dealopen";
import EndGame from "../views/EndGame";
import RoomDetails from "../views/RoomDetails";
function Navigator() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/role-selection" element={<RoleSelection />} /> {/* Add this route */}
          <Route path="/admin/auth" element={<AdminAuth />} /> 
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/assets" element={<AssetManagement />} />
          <Route path="/room" element={<Room />} />
          <Route path="/admin/room/:id" element={<RoomDetails />} />
          <Route path="/name" element={<Name />} />
          <Route path="/gameboard" element={<Gameboard />} />
          <Route path="/cardoverlay" element={<Cardoverlay />} />
          <Route path="/dealopen" element={<Dealopen />} />
          <Route path="/cardoverlay1" element={<Cardoverlay1 />} />
          <Route path="/cardoverlays" element={<Cardoverlays />} />
          <Route path="/cardoverlay3" element={<Cardoverlay3 />} />
          <Route path="/opensituation" element={<Opensituation />} />
          <Route path="/cardoverlayevry" element={<Cardoverlayevry />} />
          <Route path="/cardoverlayCommon" element={<CardoverlayCommon />} />
          <Route path="/endgame" element={<EndGame />} />
        </Routes>
      </Router>
    </Provider>
  );
}
export default Navigator;
